import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 container flex',
    rowImage:
      'flex w-full flex-wrap items-center gap-20 lg:mx-auto lg:max-w-320 lg:flex-nowrap',
    rowText:
      'flex w-full flex-wrap items-center gap-4 lg:mx-auto lg:max-w-320 lg:flex-nowrap lg:gap-15',
    main: 'xl:min-w-120',
    visual: 'relative hidden flex-none lg:block xl:h-120 xl:w-120',
    visualWrap:
      'left-0: pointer-events-none absolute top-0 opacity-0 duration-300 ease-out xl:h-120 xl:w-120',
    visualLink:
      'absolute right-0 bottom-21 left-0 mx-auto hidden w-fit items-center gap-4 rounded-[100px] p-1 pl-6 text-xl font-semibold text-black shadow-[0px_0px_12px_0px_rgba(0,0,0,0.05)] backdrop-blur-[30px] xl:flex',
    visualLinkText: 'text-white',
    visualLinkIcon:
      'flex h-15 w-15 items-center justify-center rounded-full bg-[#00C389] text-white',
    title: 'text-[56px] leading-[1.2] italic lg:text-[80px]',
    subtitle: 'mb-3 text-xl leading-[1.4] font-semibold lg:mb-8 lg:text-2xl',
    text: 'mb-3 text-base leading-[1.5] lg:mb-8 lg:text-lg',
    link: 'flex items-center gap-1.5 py-[14.5px] text-base font-semibold uppercase lg:gap-4.5',
    items: 'w-full',
    itemsTitle: 'mb-5 text-2xl leading-[1.2] lg:mb-8 lg:text-5xl',
    itemsList: '',
    image: 'rounded-full',
    item: 'group relative flex cursor-pointer items-center gap-5 rounded-tr-[1000px] rounded-br-[1000px] not-first:-mt-3 before:absolute before:top-4 before:right-0 before:bottom-4 before:left-20 before:rounded-tr-[1000px] before:rounded-br-[1000px] before:opacity-0 before:duration-300 hover:before:opacity-100 lg:gap-8 lg:not-first:-mt-6',
    itemImage:
      'z-1 max-w-30 min-w-30 rounded-full border-2 border-white lg:max-w-50 lg:min-w-50',
    info: 'relative z-1 grid w-full gap-2 lg:pr-15',
    infoTitle: 'text-xl leading-[1.4] font-semibold lg:text-2xl',
    infoText:
      'pr-7 text-sm leading-[1.4] font-light md:pr-0 lg:pr-5 lg:text-base',
    iconBioderma: 'min-h-7 min-w-29 lg:min-h-10 lg:min-w-37',
    iconEsthederm: 'min-h-9 min-w-22 lg:min-h-10 lg:min-w-27',
    iconEtatpur: 'min-h-7 min-w-26 lg:min-h-10 lg:min-w-33',
    arrow:
      'absolute top-1/2 right-0 mt-5 -translate-y-1/2 opacity-100 md:right-8 md:mt-0 lg:opacity-0 lg:group-hover:opacity-100'
  },
  variants: {
    activeImage: {
      true: {
        visualWrap: 'pointer-events-auto opacity-100'
      }
    },
    activeItem: {
      true: {
        item: 'before:opacity-100'
      }
    },
    variant: {
      primary: {},
      secondary: {}
    }
  },
  compoundVariants: [
    {
      variant: 'primary',
      activeItem: true,
      className: {
        item: 'lg:before:bg-blue-light lg:hover:before:bg-blue-light'
      }
    },
    {
      variant: 'secondary',
      activeItem: true,
      className: {
        item: 'lg:before:bg-white lg:hover:before:bg-white'
      }
    }
  ],
  defaultVariants: {
    variant: 'primary'
  }
});
